import { Component, OnInit,ElementRef, AfterViewInit, ViewChild } from '@angular/core';
import { Http, Headers, Response,RequestOptions} from '@angular/http';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { AlertService,UserService } from '../_services/index';
declare let $: any;
declare let Ladda:any
import { DatePipe } from '@angular/common';
import { NgForm } from '@angular/forms';
import { environment } from '../../environments/environment';
import { Router, ActivatedRoute,Params} from '@angular/router';
import { Helper } from '../_helpers/index';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-branchscancode',
  templateUrl: './branchscancode.component.html',
  styleUrls: ['./branchscancode.component.css'],
})

export class BranchscancodeComponent{
  backendUrl:any;
  sel_id:any;
  loadingnew = false;
  loading = false;
  complexForm:FormGroup;
  model: any = {};
  id:number;
  code_url:any;
  data1:any;
  data2:any;
  time_zone:any;

constructor(fb: FormBuilder,private http: Http,private datePipe: DatePipe,private userService:UserService,private router: Router,private activatedRoute: ActivatedRoute,private helper: Helper) {
    this.complexForm = fb.group({
      // To add a validator, we must first convert the string value into an array. The first item in the array is the default value if any, then the next item in the array is the validator. Here we are adding a required validator meaning that the firstName attribute must have a value in it.

      // We can use more than one validator per field. If we want to use more than one validator we have to wrap our array of validators with a Validators.compose function. Here we are using a required, minimum length and maximum length validator.

    })

  }
  ngOnInit(){
  let url=window.location.hostname;
    // if(url=='app.foodbot.ai'){this.backendUrl=environment.prod}
    // else if(url=='stage.foodbot.ai'){ this.backendUrl=environment.stage}
    // else if(url=='uat.foodbot.ai'){ this.backendUrl=environment.uat}
    // else{ this.backendUrl=environment.local}
    if (url == 'app.foodbot.ai' || url == 'dashboard.foodbot.ai') { this.backendUrl = environment.prod } else if (url == 'stage.foodbot.ai') { this.backendUrl = environment.stage } 
    else if (url == 'uat.foodbot.ai') { this.backendUrl = environment.uat } 
    else if (url == '127.0.0.1') { this.backendUrl = environment.local } 
    else { 
      this.backendUrl=window.location.origin
      this.backendUrl+="/apis"
    }

     let currentUser = JSON.parse(localStorage.getItem('currentUser'));
     let restaurant_id=currentUser.restaurant_id;
     this.time_zone = currentUser.time_zone ? currentUser.time_zone : 'America/Mexico_City';

     let sql="SELECT b.branch_id,s.code_url,s.code FROM fb_branches b left join fb_scan_codes s on b.branch_id = s.branch_id where b.restaurant_id="+restaurant_id+" order by b.branch_id DESC" 
     let headers = new Headers ({  'Content-Type': 'application/json' });
     let options = new RequestOptions({ headers: headers, method: "post" });

      this.userService.getdata(this.backendUrl,JSON.stringify({'query': sql}))
            .subscribe(data => {
            if(data.length > 0) {
            this.code_url = data[0].code_url;
            this.id = data[0].branch_id;
            }
          });

$(document).ready(function(){

            })
  }

  downloadFile() {
  setTimeout(()=>{
  console.log(this.id);
     if(this.id == undefined) {
        alert('Oops, Seems Branch address is not added yet. Please add first and try.');
        return false;
     }
     $('.fullpageloader').css('display','block');
     let currentUser = JSON.parse(localStorage.getItem('currentUser'));
     let restaurant_id=currentUser.restaurant_id;
     let date=new Date();
     let date_time=moment(date).format("YYYY-MM-DD HH:mm:ss");
     var filename = restaurant_id+''+this.id+''+date_time;
     if(this.code_url != null) {     
     fetch(this.code_url)
          .then(res => res.blob()) 
          .then(blob => {
          saveAs(blob, filename);
          $('.fullpageloader').hide();
        });        
     }else {            
        let data = {'restaurant_id':restaurant_id,'branch_id':this.id};
        this.userService.getbranchcode(this.backendUrl,JSON.stringify({'data':data}))
            .subscribe(data => {
            this.data1 = data;
            console.log(this.data1);
            if(this.data1.success == 'on') {
                let code_url = this.data1.code_url;
                let codes = this.data1.code;
                this.userService.upload_image_url(this.backendUrl,JSON.stringify({"image_url":code_url,"des_path":"branch_scancode"}))                
                .subscribe(
                    data => {
                    this.data2 = data;
                      if(this.data2.success == 'on') {
                      let scan_data = {
                          branch_id : this.id,
                          restaurant_id : restaurant_id,
                          code_url : this.data2.url,
                          code : codes,
                          date_time : this.helper.getDateTimeInClientTz(date_time,this.time_zone)
                        };
                        let sql="insert into fb_scan_codes SET ?"
                        this.userService.insert(this.backendUrl,({'query': sql,'data':scan_data}))
                          .subscribe(data => {
                            fetch(this.data2.url)
                              .then(res => res.blob()) 
                              .then(blob => {
                              saveAs(blob, filename);
                              $('.fullpageloader').hide();
                            },
                          error=>{
                                   $('.fullpageloader').hide();
                                });                            
                             this.ngOnInit();
                          });
                      }

                    },
                          error=>{
                                   $('.fullpageloader').hide();
                                }
                )
            }else {
                  $('.fullpageloader').hide();
                   $('#fail').html('Oops, seems facebook page is either disconnected or unpublished.');
                   $('#fail').show();
                   setTimeout(function(){
                           $('#fail').hide();
                    },3000);
            }
        },
                          error=>{
                                   $('.fullpageloader').hide();
                                });

     }
},1000)
  }
}



// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/branchscancode/branchscancode.component.ts